import {
	Box,
	Collapse,
	Fade,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	SxProps,
	Tooltip,
	Typography,
	Zoom
} from '@mui/material';
import { MOBILE_SUPPORTED_ROUTES } from 'constants/routes';
import { useLowResolution } from 'hooks';
import React, { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { IProps } from 'types/common';

interface INavigationListItemProps extends IProps {
	onClick?: (route: string) => void;
	isOpen: boolean;
	pageRoute: string;
	translation: string;
	Icon: any;
	sx?: SxProps;
}

const NavigationListItem: FC<INavigationListItemProps> = ({
	onClick,
	isOpen,
	pageRoute,
	translation,
	sx,
	Icon
}) => {
	const location = useLocation();
	const lowRes = useLowResolution();
	const mobileSupported = MOBILE_SUPPORTED_ROUTES.includes(pageRoute);
	const disabled = !mobileSupported && lowRes;

	return (
		<Box data-testid="navigation-menu-list-item">
			<ListItem
				key={pageRoute}
				disablePadding
				sx={{
					...{
						pt: '4px'
					},
					...sx
				}}
			>
				<Tooltip
					title={translation}
					disableHoverListener={isOpen}
					arrow
					placement="right"
					TransitionComponent={Zoom}
					enterDelay={500}
				>
					<ListItemButton
						onClick={onClick ? () => onClick(pageRoute) : undefined}
						to={pageRoute}
						component={Link}
						data-testid="ncm-button"
						selected={location.pathname.includes(pageRoute)}
						disabled={!!disabled}
						dense
						sx={{
							minHeight: 32,
							borderRadius: 2
						}}
					>
						<Box display="flex" alignItems="center" flexGrow={1}>
							<ListItemIcon
								sx={{
									minWidth: 24
								}}
							>
								<Icon
									fontSize="small"
									sx={{
										color: 'text.secondary'
									}}
								/>
							</ListItemIcon>
							<Collapse orientation="horizontal" in={isOpen} timeout={200}>
								<Fade in={isOpen} timeout={200}>
									<Box display="flex" flexGrow={1} justifyContent="flex-start">
										<ListItemText
											data-testid="ncm-text"
											primary={
												<Typography
													color="text.secondary"
													variant="body2"
													pl={1}
												>
													{translation}
												</Typography>
											}
											disableTypography
										/>
									</Box>
								</Fade>
							</Collapse>
						</Box>
					</ListItemButton>
				</Tooltip>
			</ListItem>
		</Box>
	);
};

NavigationListItem.defaultProps = {
	onClick: undefined,
	sx: {}
};

export default NavigationListItem;
